import { render, staticRenderFns } from "./EditPortPage.vue?vue&type=template&id=267f3164&"
import script from "./EditPortPage.vue?vue&type=script&lang=js&"
export * from "./EditPortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports